import { render, staticRenderFns } from "./ModalCongestionSituation.vue?vue&type=template&id=43545186&"
import script from "./ModalCongestionSituation.vue?vue&type=script&lang=js&"
export * from "./ModalCongestionSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports